module.exports = __webpack_public_path__ + "img/light_neutrals.ec2030e4.svg";